var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-pie-chart"},[_c('div',{staticClass:"title"},[_vm._v("运输货物类型占比")]),_c('dv-active-ring-chart',{staticClass:"pie-chart",staticStyle:{"width":"314px","height":"291px"},attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }